<mat-toolbar>
  <div>
    <img alt="appName" src="assets/logo3-1-r.png" height="44" width="250">
  </div>
  <span fxFlex></span>
  <app-menu-topbar></app-menu-topbar>
  <app-user-profile-menu></app-user-profile-menu>
</mat-toolbar>
